<template>
  <div>
    <div :id="`captcha-element-${_uid}`"></div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    sceneId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      captcha: null,
    };
  },
  mounted() {
    window.initAliyunCaptcha({
      SceneId: this.sceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
      element: `#captcha-element-${this._uid}`, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      button: `#${this.id}`, // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
      // 验证码验证通过回调函数
      success: (captchaVerifyParam) => {
        // 入参为验签captchaVerifyParam
        // 1.根据校验结果来进行业务处理
        this.$emit("success", captchaVerifyParam);
        this.initAliyunCaptcha();
      },
      // 验证码验证不通过回调函数
      fail: function (result) {
        // 入参为不通过信息
        // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
        console.error(result);
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: (instance) => {
        this.$emit("getInstance", instance);
        this.captcha = instance;
      },
      slideStyle: {
        width: 360,
        height: 40,
      }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
      language: localStorage.getItem("language") || "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
    });
  },
  methods: {
    initAliyunCaptcha() {
      window.initAliyunCaptcha({
        SceneId: this.sceneId, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        mode: "popup", // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
        element: `#captcha-element-${this._uid}`, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        button: `#${this.id}`, // 触发验证码弹窗的元素。button表示单击登录按钮后，触发captchaVerifyCallback函数。您可以根据实际使用的元素修改element的值
        // 验证码验证通过回调函数
        success: (captchaVerifyParam) => {
          // 入参为验签captchaVerifyParam
          // 1.根据校验结果来进行业务处理
          this.$emit("success", captchaVerifyParam);
          this.initAliyunCaptcha();
        },
        // 验证码验证不通过回调函数
        fail: function (result) {
          // 入参为不通过信息
          // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
          console.error(result);
        },
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: (instance) => {
          this.$emit("getInstance", instance);
          this.captcha = instance;
        },
        slideStyle: {
          width: 360,
          height: 40,
        }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
        language: localStorage.getItem("language") || "cn", // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
      });
    },
  },
};
</script>

<style>
#aliyunCaptcha-checkbox-logo {
  display: none;
}
</style>
